// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
var inject = allVue.inject;
import { toItems, toOccurrences } from '../../services/main';
import { SchedulerItem } from '../../items/SchedulerItem';
import { SchedulerViewItem } from '../../items/SchedulerViewItem';
import { mapItemsToSlots } from '../../utils/main';
/** @hidden */
var SchedulerResizeVue2 = {
  name: 'KendoSchedulerResize',
  inheritAttrs: false,
  props: {
    ignoreIsAllDay: Boolean,
    dataItem: Object,
    format: String,
    vertical: Boolean,
    viewItem: [String, Function, Object],
    item: {
      type: Object,
      default: function _default() {
        return SchedulerItem;
      }
    }
  },
  inject: {
    ks: {
      default: null
    },
    bv: {
      default: null
    }
  },
  computed: {
    occurrences: function occurrences() {
      return toOccurrences([this.$props.dataItem], {
        dateRange: this.ks.dateRange,
        fields: this.ks.fields,
        timezone: this.ks.timezone
      });
    },
    items: function items() {
      return toItems(this.occurrences, {
        timezone: this.ks.timezone
      }, {
        groups: this.ks.groups,
        ranges: this.bv.ranges
      });
    }
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    var slots = (this.bv.slots || []).map(function (s) {
      return s;
    });
    mapItemsToSlots(this.items, slots);
    var itemsToRender = this.v3 ? this.items : this.items && this.items.length ? [this.items[0]] : [];
    if (!itemsToRender.length) {
      return null;
    }
    return itemsToRender.map(function (item, idx) {
      return h(SchedulerViewItem, {
        key: idx,
        uid: item.uid,
        attrs: this.v3 ? undefined : {
          uid: item.uid,
          start: item.start,
          end: item.end,
          originalStart: item.originalStart,
          startTimezone: item.startTimezone,
          endTimezone: item.endTimezone,
          isAllDay: item.isAllDay,
          title: item.title,
          description: item.description,
          occurrenceId: item.occurrenceId,
          recurrenceExceptions: item.recurrenceExceptions,
          recurrenceRule: item.recurrenceRule,
          recurrenceId: item.recurrenceId,
          dataItem: item.dataItem,
          itemRef: item.itemRef,
          head: item.head,
          tail: item.tail,
          order: item.order,
          zonedStart: item.zonedStart,
          zonedEnd: item.zonedEnd,
          slots: item.slots,
          group: item.group,
          range: item.range,
          isException: item.isException,
          isRecurring: item.isRecurring,
          format: this.format
          //   item={this.$props.item}
          ,
          resizeHint: true,
          vertical: this.$props.vertical,
          ignoreIsAllDay: this.$props.ignoreIsAllDay
        },
        start: item.start,
        end: item.end,
        originalStart: item.originalStart,
        startTimezone: item.startTimezone,
        endTimezone: item.endTimezone,
        isAllDay: item.isAllDay,
        title: item.title,
        description: item.description,
        occurrenceId: item.occurrenceId,
        recurrenceExceptions: item.recurrenceExceptions,
        recurrenceRule: item.recurrenceRule,
        recurrenceId: item.recurrenceId,
        dataItem: item.dataItem,
        itemRef: item.itemRef,
        head: item.head,
        tail: item.tail,
        order: item.order,
        zonedStart: item.zonedStart,
        zonedEnd: item.zonedEnd,
        slots: item.slots,
        group: item.group,
        range: item.range,
        isException: item.isException,
        isRecurring: item.isRecurring,
        format: this.format,
        resizeHint: true,
        vertical: this.$props.vertical,
        ignoreIsAllDay: this.$props.ignoreIsAllDay
      });
    }, this);
  }
};
/** @hidden */
var SchedulerResize = SchedulerResizeVue2;
export { SchedulerResize, SchedulerResizeVue2 };